import { render } from "./StockAddModal.vue?vue&type=template&id=1bf3a612&scoped=true&ts=true"
import script from "./StockAddModal.vue?vue&type=script&lang=ts"
export * from "./StockAddModal.vue?vue&type=script&lang=ts"

import "./StockAddModal.vue?vue&type=style&index=0&id=1bf3a612&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf3a612"]])

export default __exports__